module.exports = "images/11ans.dce5a3e7.png";